<!-- <div class="card mb-3">
    <div class="row g-0">
        <div class="col-md-4">
            <img [src]="imgEvent" class="img-fluid" alt="..." (error)="handleImageError($event)" />
        </div>
        <div class="col-md-8">
            <div class="card-body">
                <h5 class="card-title">{{ title }}</h5>
                <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                <p class="card-text"><small class="text-body-secondary">Last updated 3 mins ago</small></p>
            </div>
            <div class="card-footer">
                <a [routerLink]="['/private/events/create-event', uuidEvent]">event</a>
            </div>
        </div>
    </div>
</div>
<div class="card">
    <div class="card-body"></div>
</div> -->

<!-- <div class="card shadow-sm border rounded-4 p-3 mb-3">
    <div class="row g-3 align-items-center">
        <div class="col-3 text-center border-end">
            <div class="calendar bg-light p-3 rounded-3">
                <div class="icon text-primary">
                    <i class="bi bi-calendar-check-fill fs-3"></i>
                </div>
                <div class="date fw-bold fs-4">{{ start_date | date : 'd' }}</div>
                <div class="month text-muted">{{ month }}</div>
            </div>
            <div class="time text-dark mt-2"><i class="bi bi-clock"></i> {{ start_hour }}</div>
            <div class="text-primary fw-bold mt-1">{{ subscribers }} Inscritos</div>
        </div>

        <div class="col">
            <h5 class="fw-bold text-primary">
                {{ title }}
            </h5>
            <p class="text-muted mb-1">{{ description }}</p>
            <p class="fw-bold"><i class="bi bi-person-fill"></i> {{ event.organizador }}</p>
        </div>

        <div class="col-md-2 border">
            <img [src]="imgEvent" class="img-fluid rounded-3" alt="event" (error)="handleImageError($event)" />
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 text-end">
            <button class="btn btn-outline-primary btn-sm"><i class="bi bi-pencil"></i> Inscribirse</button>
            <button class="btn btn-outline-primary btn-sm"><i class="bi bi-share"></i> Compartir</button>
            <button class="btn btn-outline-primary btn-sm"><i class="bi bi-eye"></i> Ver event</button>
        </div>
    </div>
</div> -->
<div class="card-body d-flex flex-column card-body-box-content">
    <div class="row">
        <div class="col-lg-3 d-flex flex-column justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-start align-items-center card-body-date-event border-end">
            <i class="far fa-calendar-check fa-1x d-flex card-body-calendar-icon text-primary" aria-hidden="true">
                <div class="d-flex flex-column card-body-date">
                    <span>{{ start_date | date : 'd' }}</span>
                    <span>{{ month }}</span>
                </div>
            </i>
            <hr class="hr" />
            <div class="card-body-hour">
                <i class="far fa-clock card-body-clock-icon d-flex align-items-center">
                    <p>{{ start_hour }}</p>
                </i>
            </div>
            <div class="card-body-registered">
                <p class="text-primary">{{ subscribers }} Inscritos</p>
            </div>
        </div>
        <div class="col-lg-8 d-flex flex-column">
            <div class="d-sm-flex flex-sm-column flex-md-column flex-lg-column flex-xl-row">
                <div class="card-body-text w-100">
                    <div class="card-title text-primary">{{ title }}</div>
                    <p>{{ description }}</p>
                </div>
                <div class="card-body-image flex-shrink-1">
                    <img class="img-fluid" [src]="event.vc_photo_event" alt="" (error)="handleImageError($event)" />
                </div>
            </div>
            <div class="d-flex flex-column card-body-event-organizer">
                <!-- <div class="card-body-event-organizer-user">
                    <i class="d-flex fas fa-user-friends text-primary">
                        <h6>
                            {{ event.creador }}
                        </h6>
                    </i>
                </div> -->

                <div class="d-flex justify-content-end gap-2 card-body-buttons mt-3" *ngIf="!(cancelled || published)">
                    <!-- <button [hidden]="true" type="button" id="btNoSeguir{{ event.i_pk_id }}" class="btn boton-shared" (click)="deleteInscripcion(event.i_pk_id, event.vc_uuid_user)"><i class="fa fa-pencil-square-o"></i>INSCRITO</button>
                    <button [hidden]="true" type="button" class="btn boton-shared" id="btSeguir{{ event.i_pk_id }}" (click)="saveInscripcion(event.i_pk_id, event.start_date, event.vc_uuid_user)"><i class="fa fa-pencil-square-o"></i>Inscribirse</button>
                    <button type="button" class="btn boton-shared" (click)="modalOpen(modal, event.vc_uuid)"><i class="fa fa-share-alt"></i>Compartir</button> -->
                    <!-- <button type="button" placement="top" class="btn boton-shared" (click)="irEvento(event.vc_uuid)"><i class="fas fa-eye"></i>Ver evento</button> -->
                    <button type="button" class="btn btn-outline-danger btn-sm" (click)="handleAction('cancelar')"><i class="fas fa-times me-2"></i>Cancelar</button>
                    <button class="btn btn-outline-primary btn-sm" (click)="redirect()"><i class="fas fa-edit me-2"></i>Editar</button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="handleAction('publicar')">Publicar</button>
                </div>
            </div>
        </div>
    </div>
</div>
